import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";
import CustomToast from "src/components/CustomToast/CustomToast";
import cmsClient from "src/services/cmsClient";

interface MoveQuickLinkOptions {
	id: number;
	offset: number;
}

const moveQuickLink = async ({ id, offset }: MoveQuickLinkOptions) => {
	const url = `/homepage/admin/quicklink/${id}/move/`;
	const response = await cmsClient.put<unknown>(url, { offset });

	return response.data;
};

const useMoveQuickLink = () => {
	const queryClient = useQueryClient();

	const onSuccess = () => {
		queryClient.invalidateQueries(["quick-links"]);
	};

	const onError = () => {
		toast.error(
			<CustomToast type="Error" message="Something went wrong reordering" />,
			{ hideProgressBar: true }
		);
	};

	const mutation = useMutation(moveQuickLink, {
		onError,
		onSuccess
	});

	return mutation;
};

export default useMoveQuickLink;
